// import local from '../../../local/ar';
import api from '../services/request-detail-api';

// const actionNames = local.bankruptcy.actions;

export default {
  submitAddNewPartner(_context, payload) {
    return api
      .submitAddNewPartner(payload.requestObjectKey, payload)
      .then(res => res.data);
  },
  submitAddNewBranch(_context, payload) {
    return api
      .submitAddNewBranch(payload.requestObjectKey, payload)
      .then(res => res.data);
  },
  submitAddNewBankruptDebt(_context, payload) {
    return api
      .submitAddNewBankruptDebt(payload.requestObjectKey, payload)
      .then(res => res.data);
  },
  submitAddNewBankruptDueRight(_context, payload) {
    return api
      .submitAddNewBankruptDueRight(payload.requestObjectKey, payload)
      .then(res => res.data);
  },
  submitAddNewDebtorAsset(_context, payload) {
    return api
      .submitAddNewDebtorAsset(payload.requestObjectKey, payload)
      .then(res => res.data);
  },
  submitAddNewDebtorEmployee(_context, payload) {
    return api
      .submitAddNewDebtorEmployee(payload.requestObjectKey, payload)
      .then(res => res.data);
  },
  submitAddNewInterestParty(_context, payload) {
    return api
      .submitAddNewInterestParty(payload.requestObjectKey, payload)
      .then(res => res.data);
  },
  getPartnersByRequestObjectKey(_context, payload) {
    return api.getPartnersByRequestObjectKey(payload);
  },
  getInterestedPartiesByRequestObjectKey(_context, payload) {
    return api.getInterestedPartiesByRequestObjectKey(payload);
  },
  getPartner(_context, payload) {
    return api.getPartner(payload);
  },
  getBranchesByRequestObjectKey(_context, payload) {
    return api.getBranchesByRequestObjectKey(payload);
  },
  getDebtorAssetsByRequestObjectKey(_context, payload) {
    return api.getDebtorAssetsByRequestObjectKey(payload);
  },
  getBankruptDebtsByRequestObjectKey(_context, payload) {
    return api.getBankruptDebtsByRequestObjectKey(payload);
  },
  getBankruptDueRightByRequestObjectKey(_context, payload) {
    return api.getBankruptDueRightByRequestObjectKey(payload);
  },
  getDebtorEmployeesByRequestObjectKey(_context, payload) {
    return api.getDebtorEmployeesByRequestObjectKey(payload);
  },
  getBranch(_context, payload) {
    return api.getBranch(payload);
  },
  getDebtorAsset(_context, payload) {
    return api.getDebtorAsset(payload);
  },
  getBankruptDebt(_context, payload) {
    return api.getBankruptDebt(payload);
  },
  getBankruptDueRight(_context, payload) {
    return api.getBankruptDueRight(payload);
  },
  getDebtorEmployee(_context, payload) {
    return api.getDebtorEmployee(payload);
  },
  getInterestParty(_context, payload) {
    return api.getInterestParty(payload);
  },
  updatePartner(_context, payload) {
    return api
      .updatePartner(payload.requestObjectKey, payload)
      .then(res => res.data);
  },
  updateBranch(_context, payload) {
    return api
      .updateBranch(payload.requestObjectKey, payload)
      .then(res => res.data);
  },
  updateDebtorAsset(_context, payload) {
    return api
      .updateDebtorAsset(payload.requestObjectKey, payload)
      .then(res => res.data);
  },
  updateBankruptDebt(_context, payload) {
    return api
      .updateBankruptDebt(payload.requestObjectKey, payload)
      .then(res => res.data);
  },
  updateBankruptDueRight(_context, payload) {
    return api
      .updateBankruptDueRight(payload.requestObjectKey, payload)
      .then(res => res.data);
  },
  updateDebtorEmployee(_context, payload) {
    return api
      .updateDebtorEmployee(payload.requestObjectKey, payload)
      .then(res => res.data);
  },
  updateInterestParty(_context, payload) {
    return api
      .updateInterestParty(payload.requestObjectKey, payload)
      .then(res => res.data);
  },
  deletePartner(_context, payload) {
    return api.deletePartner(payload);
  },
  deleteBranch(_context, payload) {
    return api.deleteBranch(payload);
  },
  deleteDebtorAsset(_context, payload) {
    return api.deleteDebtorAsset(payload);
  },
  deleteBankruptDebt(_context, payload) {
    return api.deleteBankruptDebt(payload);
  },
  deleteBankruptDueRight(_context, payload) {
    return api.deleteBankruptDueRight(payload);
  },
  deleteDebtorEmployee(_context, payload) {
    return api.deleteDebtorEmployee(payload);
  },
  deleteInterestParty(_context, payload) {
    return api.deleteInterestParty(payload);
  },
  getPartiesByStakeholderType(_context, payload) {
    return api.getPartiesByStakeholderType(payload);
  },

};
